var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      responsive: "",
      hover: "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "no-local-sorting": "",
    },
    on: {
      "update:sortBy": function ($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function ($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function ($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function ($event) {
        _vm.sortDesc = $event
      },
      "sort-changed": function ($event) {
        return _vm.$emit("sort-changed", $event)
      },
      "row-clicked": _vm.onClickRow,
    },
    scopedSlots: _vm._u([
      {
        key: "cell(license_number)",
        fn: function (data) {
          return [
            _c("span", [_vm._v(_vm._s(data.item.license_number))]),
            _vm._v(" "),
            data.item.is_on_greenlists
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        modifiers: { hover: true },
                      },
                    ],
                    staticClass: "greenlists-indicator ml-1",
                    attrs: { title: "On Greenlists" },
                  },
                  [_vm._v("\n            G\n        ")]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(location)",
        fn: function (data) {
          return [
            _vm._v(
              "\n        " +
                _vm._s(
                  [data.item.street, data.item.city].filter(Boolean).join(", ")
                ) +
                "\n    "
            ),
          ]
        },
      },
      {
        key: "cell(enriched_at)",
        fn: function (data) {
          return [
            _vm._v(
              "\n        " +
                _vm._s(_vm.formatDate(data.item.enriched_at)) +
                "\n    "
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }